var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import Icon from "@cloudscape-design/components/icon";
import { Toolbar } from "../toolbar";
import "./DockedToolbar.css";
import { NotificationList } from "../notification-list";
import { useToolbarCollapseStore } from "../floating-toolbar/hook/useToolbarCollapseStore";
import { useToolbarTutorialStore } from "../floating-toolbar/hook/useToolbarTutorialStore";
import Hotspot from "@cloudscape-design/components/hotspot";
import classNames from "classnames";
export var DockedToolbar = function (_a) {
    var _b, _c, _d;
    var _e = _a.withHotspot, withHotspot = _e === void 0 ? false : _e, props = __rest(_a, ["withHotspot"]);
    var isCollapsed = props.isCollapsed, isCollapsible = props.isCollapsible, i18nStrings = props.i18nStrings, onCollapseChange = props.onCollapseChange;
    var ariaLabelExpandToolbarButton = i18nStrings.ariaLabelExpandToolbarButton;
    var _f = useToolbarCollapseStore(), collapsed = _f.collapsed, setCollapsed = _f.setCollapsed;
    React.useEffect(function () {
        setCollapsed(isCollapsed);
    }, [isCollapsed]);
    var _g = useToolbarTutorialStore(), setShowTutorial = _g.setShowTutorial, setTutorialCompleted = _g.setTutorialCompleted;
    useEffect(function () {
        if (!withHotspot) {
            setShowTutorial(false);
            setTutorialCompleted(true);
        }
    }, [withHotspot]);
    var dockedNotificationItems = (_c = (_b = props.dockedNotificationListProps) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [];
    var showDockedNotification = dockedNotificationItems.length > 0;
    useEffect(function () {
        if (onCollapseChange) {
            onCollapseChange(collapsed);
        }
    }, [collapsed, onCollapseChange]);
    return (_jsxs(_Fragment, { children: [withHotspot && (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "hotspot5" }, { children: _jsx(Hotspot, { direction: "bottom", hotspotId: "hotspot5" }) })) })), _jsxs("div", __assign({ className: "docked-toolbar-wrapper" }, { children: [_jsx(Toolbar, __assign({}, props, { isCollapsed: collapsed, isFloating: false })), showDockedNotification && (_jsx("div", __assign({ className: "docked-toolbar-notification-wrapper" }, { children: _jsx(NotificationList, { ariaLabel: (_d = props.dockedNotificationListProps) === null || _d === void 0 ? void 0 : _d.ariaLabel, items: dockedNotificationItems, shadowEffect: true }) }))), isCollapsible !== false && (_jsx("div", __assign({ className: classNames("toolbar-expand-button-container", collapsed ? "collapsed" : "expanded") }, { children: _jsx("button", __assign({ className: "toolbar-expand-button", onClick: function () {
                                setCollapsed(!collapsed);
                            }, "aria-label": ariaLabelExpandToolbarButton }, { children: _jsx(Icon, { name: collapsed ? "angle-down" : "angle-up", size: "inherit" }) })) })))] }))] }));
};
export default DockedToolbar;
